import useAppStore from "@/store/app";
import useSistemaStore from "@/store/sistema";
import useRootStore from "@/store/root";
import { useRoute } from "vue-router";

export default function useUtils() {
  const route = useRoute();
  const app_store = useAppStore();
  const root_store = useRootStore();
  const sistema_store = useSistemaStore();
  const { loading } = storeToRefs(root_store);
  const { sistema } = storeToRefs(sistema_store);
  // console.log(route)
  const route_layout = ref(route?.meta?.layout || "vertical");

  const production_paypal = computed(() => sistema.value.production_paypal);
  const paypal_id = computed(() => sistema.value.paypal_id);
  const paypal_secret = computed(() => sistema.value.paypal_secret);
  const paypal = computed(() => sistema.value.paypal);

  const is_layout_public = computed(() => route_layout.value === "full");

  const datos_paypal = computed(() => {
    return {
      clientId: paypal_id.value,
      environment: production_paypal.value ? "production" : "sandbox",
    };
  });

  const url_app = import.meta.env.VITE_APP_URL || "https://imprenta.dev:5173";

  const ir = (id_element) => {
    const element = document.getElementById(id_element);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const {
    windowWidth,
    isScreenMovil,
    isMenorQue,
    anchoSidebar,
    currentBreakPoint,
    colorsTheme,
  } = storeToRefs(app_store);

  // getters
  const ancho_popover = computed(() => {
    if (windowWidth.value > 992) return "450";
    if (windowWidth.value > 662) return "420";
    if (windowWidth.value > 300) return "300";
  });

  watch(route, () => {
    route_layout.value = route.meta.layout || null;
  });

  return {
    datos_paypal,
    ancho_popover,
    windowWidth,
    isScreenMovil,
    anchoSidebar,
    loading,
    currentBreakPoint,
    colorsTheme,
    url_app,
    is_layout_public,
    route_layout,
    route,
    // methods
    isMenorQue,
    ir,
  };
}
